import React, { useState } from "react";
import { Tabs, Tab } from "react-bootstrap";
import { PageHeader } from "src/components";
import { CSVUserForm, IndividualUserForm, MultipleUserForm } from "./";

function CreateUserComponent() {
  const [activeTab, setActiveTab] = useState("individual");

  return (
    <>
      <PageHeader>
        <h1>Create User</h1>
      </PageHeader>
      <Tabs activeKey={activeTab} onSelect={eventKey => setActiveTab(eventKey || 'individual')}>
        <Tab eventKey="individual" title="Individual">
          <IndividualUserForm />
        </Tab>
        <Tab eventKey="multiple" title="Multiple">
          <MultipleUserForm />
        </Tab>
        <Tab eventKey="csv" title="CSV">
          <CSVUserForm />
        </Tab>
      </Tabs>
    </>
  );
}

export default React.memo(CreateUserComponent);
